export default __webpack_public_path__ + "static/media/main-onlydrums.d71ead93.mp3";